module.exports = __webpack_public_path__ + "static/media/compare-age.27ef7522.svg";